import { useTailorIsOpen } from 'app/hooks/useTailorIsOpen';
import { useTailorHasOpened } from 'app/hooks/useTailorHasOpened';
import { useEffect } from 'react';
import { rootContainer } from 'app/shadowRoot';

import usePersistedSearch from './usePersistedSearch';
import { useSearch } from './useSearch';

export function useSearchCleaner() {
  const [persistedSearch, , removePersistedSearch] = usePersistedSearch();
  const { isOpen } = useTailorIsOpen();
  const { hasOpened } = useTailorHasOpened();
  const { setSearch } = useSearch();

  useEffect(() => {
    if (!isOpen && hasOpened) {
      setSearch('');
    }
  }, [isOpen, hasOpened, setSearch]);

  useEffect(() => {
    if (persistedSearch) {
      removePersistedSearch();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const handleConditionChanged = () => {
      setSearch('');
    };

    rootContainer.addEventListener('tailor:condition-changed', handleConditionChanged);

    return () => {
      rootContainer.removeEventListener('tailor:condition-changed', handleConditionChanged);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
